"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourEditor = void 0;
const react_1 = require("@thesisedu/react");
const react_2 = __importDefault(require("react"));
const TourStepsEditor_1 = require("./editor/TourStepsEditor");
function TourEditor({ value, onChange }) {
    const form = react_1.Form.useForm();
    react_2.default.useEffect(() => {
        form.reset(value);
    }, [value]);
    return (react_2.default.createElement(react_1.Form, { form: form, onFinish: values => {
            if (onChange) {
                onChange(values);
            }
        } },
        react_2.default.createElement(TourStepsEditor_1.TourStepsEditor, null),
        react_2.default.createElement(react_1.Block, { marginTop: '@size-s', style: { textAlign: 'right' } },
            react_2.default.createElement(react_1.Form.Submit, { disableUntilDirty: true, type: 'primary', children: 'Save Changes' }))));
}
exports.TourEditor = TourEditor;
//# sourceMappingURL=TourEditor.js.map